import React from 'react';
import PropTypes from 'prop-types';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function RolesActions(props) {
  const { onClickDelete } = props;
  const {
    roles: {
      role: { role_id },
    },
  } = props;

  if (!role_id) {
    return [];
  }

  return (
    <div
      data-test="role-action"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTipIcon toolText="Delete Role">
        <button
          type="button"
          onClick={onClickDelete}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/delete_button.svg"
            alt="Delete"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
    </div>
  );
}

RolesActions.propTypes = {
  onClickDelete: PropTypes.func,
  roles: PropTypes.object.isRequired,
};

export default RolesActions;
